// extracted by mini-css-extract-plugin
export default {"AdSlotMail__mail":"bgk_a bhk_wj bhk_a bhk_q bhk_k","AdSlotMail__mail--notLoaded":"bgk_b bhk_ey bhk_bj bhk_wy","show-ad-not-loaded":"bgk_c","AdSlotMail__cta":"bgk_e"};